var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#4D4D4D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.294 17.62c-2.268-.91-4.108-2.642-5.152-4.851l-.27-.571 1.362-1.362c.184-.184.184-.481 0-.665l-2.022-2.023c-.202-.201-.535-.179-.71.046-1.815 2.322-1.115 6.262 1.71 9.086 2.824 2.825 6.764 3.525 9.086 1.71.225-.175.247-.508.046-.71l-2.023-2.022c-.184-.184-.482-.184-.665 0l-1.362 1.361z",
    transform: "translate(-245 -372) translate(16 298) translate(64 74) translate(147) translate(18) translate(4.5 3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.08 29.479c-.229 0-.455-.077-.638-.226-.289-.232-.428-.602-.364-.966l.937-5.337C.66 19.924-.352 16.162.157 12.3.982 6.051 6.12.93 12.37.121c4.402-.568 8.727.875 11.865 3.959 3.138 3.083 4.657 7.376 4.167 11.78-.71 6.377-5.86 11.623-12.244 12.475-2.56.34-5.15-.019-7.524-1.045l-5.17 2.113c-.124.051-.254.076-.385.076zm9.55-27.34c-5.353.69-9.751 5.076-10.457 10.428-.456 3.452.505 6.81 2.705 9.455.19.23.27.532.219.825l-.698 3.977 3.87-1.581c.264-.107.56-.1.817.02 2.13 1 4.483 1.366 6.803 1.057 5.471-.73 9.884-5.224 10.493-10.685.42-3.779-.882-7.463-3.572-10.105-2.69-2.644-6.402-3.88-10.18-3.391zm-.091-.962h.026-.026z",
    transform: "translate(-245 -372) translate(16 298) translate(64 74) translate(147) translate(18) translate(4.5 3)"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappOutline);
export default __webpack_public_path__ + "static/media/whatsapp-outline.e532c36c3c80b429cf4df7f82aee19de.svg";
export { ForwardRef as ReactComponent };